import React, { Fragment, useEffect, useState } from "react";
import { Button, Image, Upload } from "antd";
import {
    DeleteOutlined,
    EyeOutlined,
    LoadingOutlined,
    PlusOutlined,
    UndoOutlined,
    UploadOutlined,
} from "@ant-design/icons";
import log from "cslog";
import { useUploadFile } from "../../actions/files";
import { BASE_URL } from "../../constants";
import { restoreAccessToken } from "../../_helpers/auth";
import { getImageFileURL, getPublicImageURL } from "../../_helpers/image";
import { useBGRemove } from "../../_actions/bot";
import { useSingleItem } from "../../_actions/app/items";
import ImagePicker from "../../editor/imagepicker/ImagePicker";

import styles from "./styles/PhotoButtonMinimal.module.css";

function getImageURL(imageId) {
    return `${BASE_URL}assets/${imageId}?key=system-medium-cover&access_token=${restoreAccessToken()}`;
}

// onChange = returns image id
// onChangeFull = returns full image object
function PhotoButtonMinimal({
    field,
    value,
    onChange,
    onChangeFull = () => {},
    width = "150px",
    height = "150px",
    objectFit = "cover",
    show_placeholder = false,
    show_choose = true,
    // background = "white",
    background = "#FAFAFA",
    enable_remove_bg = false,
}) {
    const [photo, setPhoto] = useState({ id: value });
    const {
        isSuccess: successFullPhotoData,
        isLoading: loadingFullPhotoData,
        data: fullPhotoData,
    } = useSingleItem(
        "directus_files",
        `/${value}`,
        value !== undefined && enable_remove_bg,
    );

    const fileMutation = useUploadFile((data, variables, context) => {
        log.d(data, "Success Data");
        setPhoto(data);
        onChange(data.id);
        onChangeFull(data);
    });
    const mutationRemoveBG = useBGRemove((new_photo) => {
        log.d(new_photo, "Photo with bg removed");
        if (new_photo?.data?.success) {
            const photo = new_photo?.data?.file;
            log.d(photo, "Now photo success");
            setPhoto(photo);
            onChange(photo.id);
        }
    });

    // newly added
    useEffect(() => {
        setPhoto({ id: value });
    }, [value]);

    log.d(value, "Value in PhotoButton");
    log.d(fullPhotoData, "fullPhotoData in PhotoButton");

    const onFile = (eve) => {
        console.log("Got Image");
        const file = eve.target.files[0];
        if (file) {
            if (typeof file === "object" && file !== null) {
                const formData = new FormData();
                // formData.append("title", "Some title")
                formData.append("file", file);
                fileMutation.mutate(formData);
            }
        }
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                // gap: "10px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    gap: "5px",
                }}
            >
                {show_choose && (
                    <ImagePicker
                        trigger={<Button>Choose</Button>}
                        onSelect={(images) => {
                            const image = images[0];
                            log.d(image, "Image from Image Picker");
                            setPhoto(image);
                            onChange(image.id);
                            onChangeFull(image);
                        }}
                    />
                )}
                {enable_remove_bg && successFullPhotoData && (
                    <Button
                        onClick={() => {
                            mutationRemoveBG.mutate({
                                filename: fullPhotoData?.filename_disk,
                            });
                        }}
                        loading={mutationRemoveBG.isLoading}
                        disabled={
                            mutationRemoveBG.isLoading ||
                            !successFullPhotoData ||
                            fullPhotoData?.bg_removed
                        }
                    >
                        Remove background
                    </Button>
                )}
            </div>

            <div
                className={styles.wrapper}
                style={{
                    width: width,
                    maxWidth: width,
                    height: height,
                    background: background,
                }}
                onClick={(e) => {
                    e.preventDefault();
                    document
                        .getElementById(
                            `photo-${field.collection}-${field.field}`,
                        )
                        .click();
                }}
            >
                {!photo?.id && show_placeholder && (
                    <button
                        style={{
                            border: 0,
                            background: "none",
                            cursor: "pointer",
                            color: background === "black" ? "white" : "black",
                        }}
                        type="button"
                    >
                        {fileMutation.isLoading ? (
                            <LoadingOutlined />
                        ) : (
                            <PlusOutlined />
                        )}
                        <div style={{ marginTop: 8 }}>
                            {fileMutation.isLoading ? "Uploading..." : "Upload"}
                        </div>
                    </button>
                )}

                {photo.id && (
                    <div className={styles.img_preview_wrapper}>
                        <img
                            draggable={false}
                            src={getPublicImageURL(photo.id)}
                            alt="avatar"
                            style={{
                                width: width,
                                maxWidth: width,
                                height: height,
                                objectFit: "contain",
                            }}
                            className={styles.img_preview}
                        />
                        <div className={styles.img_overley}>
                            <UploadOutlined
                                style={{ color: "white", fontSize: "1.5em" }}
                            />
                            {/* <DeleteOutlined
                                style={{ color: "white", fontSize: "1.5em" }}
                            /> */}
                            <span style={{ color: "white" }}>Change</span>
                        </div>
                    </div>
                )}
            </div>
            <input
                type="file"
                name="photo"
                onChange={onFile}
                id={`photo-${field.collection}-${field.field}`}
                hidden
                style={{
                    display: "none",
                }}
            />
        </div>
    );
}

export default PhotoButtonMinimal;

// Ant design form custom field
// https://medium.com/swlh/use-custom-and-third-party-react-form-components-with-ant-design-and-typescript-2732e7849aee
